import React from 'react'
import { Helmet } from "react-helmet";

const Meta = ({title,description,keywords}) => {
  return (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
  )
}

Meta.defaultProps = {
    title: "Av Pet Shop",
    description: "we sell pets",
    keywords: "pets, buy pets, buy pets online"
}

export default Meta